<template>
  <div>
    <sweet-modal blocking width="2000px" title="Apply Over Payments" ref="applyOverPayments" v-on:close="closeModal">
      <el-row :gutter="20">
        <el-col :span="17" :offset="0">
          <el-table
            :data="tableData"
            border
            size="mini"
            style="width: 100%">
            <el-table-column
              prop="crid"
              label="CR ID"
              width="120"
              align="center">
            </el-table-column>
            <el-table-column
              label="Date"
              align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.date ? moment(scope.row.date).format("D MMM YYYY") : '' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="Owing"
              align="center">
              <template slot-scope="scope">
                <span>{{ formatPrice(scope.row.owing) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="Over PMT Bal (Cr)"
              align="right">
              <template slot-scope="scope">
                <span>{{ formatPrice(scope.row.overpmtcr) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="Amt Applied"
              align="right">
              <template slot-scope="scope">
                <money v-model="scope.row.amtApplied" @input.native="amtAppliedChange(scope.row)" v-bind="money" style="text-align: right;"></money>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="7" :offset="0">
          <div class="item grey">
            <span>Total Amount (VAT Inclusive)</span>
            <span>{{ formatPrice(totalAmountVatInclusinve) }}</span>
          </div>
          <div class="item grey">
            <span>Amount Applied</span>
            <span>{{ formatPrice(totalAmtApplied) }}</span>
          </div>
          <div class="item grey">
            <span>Amount Owing</span>
            <span>{{ formatPrice(amountOwing) }}</span>
          </div>
        </el-col>
      </el-row>

      <div class="modal__btn" style="margin-top: 20px;">
        <el-button type="primary" size="default" @click="applyModal">Apply</el-button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
  let moment = require('moment')
  import {Money} from 'v-money'

  export default {
    name: 'Use Balance',
    props: {
      amountOwing: {
        type: [Number, null],
        default: 0
      },
      totalAmountVatInclusinve: {
        type: [Number, null],
        default: 0
      },
      tableData: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    components: {
      SweetModal,
      Money,
    },
    data() {
      return {
        money: {
          precision: 2,
          decimal: '.',
          thousands: ',',
          masked: false
        },
        moment: moment,
        total: 0,
      }
    },
    computed: {
      totalAmtApplied() {
        return this.tableData.reduce((total, item) => {
          total += item.amtApplied
          return total
        }, 0)
      },
    },
    methods: {
      async open() {
        this.$refs.applyOverPayments.open()
      },
      amtAppliedChange(row) {
        if (row.amtApplied > row.overpmtcr) row.amtApplied = row.overpmtcr
        this.$emit('overPMTBal', this.totalAmtApplied)
      },
      async applyModal() {
        this.$emit('overPMTBal', this.totalAmtApplied)
        this.$refs.applyOverPayments.close()
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      closeModal() {
        // this.form.text = ''
      },
    },
  }
</script>

<style lang="scss" scoped>
.item {
  font-size: 15px;
  display: flex;
  justify-content: space-between;
  // min-width: 260px;
  padding: 6px;
  // margin-bottom: 10px;
  border: 1px solid #a9a9b0;
  &.orange {
    background-color: #f5dab1;
    min-width: 260px;
    margin-left: auto;
  }
  &.success {
    background-color: #e1f3d8;
  }
  &.grey {
    background-color: #ebeef5;
  }
  &.bold {
    font-weight: bold;
  }
  &.dots {
    border: 1px dashed #a9a9b0;
  }
  &.prices {
    align-items: center;
    justify-content: center;
    text-align: center;
    min-width: 100px;
  }
  .num {
    min-width: 85px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
  .tf-red {
    color: #F56C6C;
  }
  .tf-green {
    color: #50b944;
  }
}
/deep/.sweet-modal-overlay .sweet-modal {
  max-width: 1300px !important;
}
</style>